import React from "react";
import image1 from "../Images/image1.jpeg"

import image3 from "../Images/image3.jpeg"
import image4 from "../Images/image4.jpeg"
import Video from "../Vedios/vedio.mp4";
import Video1 from "../Vedios/vedio1.mp4";

const images = [
  {
        title: "Plumbing Accessories",
    desc: "All plumbing fittings and accessories available as per requirement.",
    img: "https://www.jbmotorsgroup.com/media/images/products/6-inch-submersible-pumpset-big_copy.jpg",
    type: "image",
  },
  {
 title: "Industrial Pipes Supply",
    desc: "High-quality pipes available for home, commercial and industrial use.",
    img: image3,
    type: "image",
  },
  {
title: "Electrical Wire & Cable",
desc: "ISI marked cables for long-lasting and safe electrical connections.",

    img: "https://tiimg.tistatic.com/fp/2/009/245/electric-wire-cables-490.jpg",
    type: "image",
  },
  {
            title: "Plumbing Accessories",
    desc: "All plumbing fittings and accessories available as per require",
    img: image4,
    type: "image",
  },
  {
    title: "Water Motors & Pumps",
    desc: "Wide range of water motors and pumps based on capacity and usage.",
    img: Video,
    type: "video", 
  },
  {
    title: "Pipe Installation Work",
    desc: "Professional pipe installation service based on site and usage needs.",
    img:  Video1,
    type: "video",
  },
];

const Slider = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center fw-bold mb-4">
        Our Exclusive Ranges
      </h2>

      <div
        id="projectSlider"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        {/* ===== SLIDES ===== */}
        <div className="carousel-inner">

          <div className="carousel-item active">
            <div className="row g-4">
              {images.slice(0, 2).map((item, i) => (
                <Card key={i} item={item} />
              ))}
            </div>
          </div>

          <div className="carousel-item">
            <div className="row g-4">
              {images.slice(2, 4).map((item, i) => (
                <Card key={i} item={item} />
              ))}
            </div>
          </div>

          <div className="carousel-item">
            <div className="row g-4">
              {images.slice(4, 6).map((item, i) => (
                <Card key={i} item={item} />
              ))}
            </div>
          </div>

        </div>

       
       {/*  DOTS NICHE */}
<div className="carousel-indicators custom-dots mt-4">
  <button data-bs-target="#projectSlider" data-bs-slide-to="0" className="active"></button>
  <button data-bs-target="#projectSlider" data-bs-slide-to="1"></button>
  <button data-bs-target="#projectSlider" data-bs-slide-to="2"></button>
</div>
      </div>
    </div>
  );
};

const Card = ({ item }) => (
  <div className="col-12 col-md-6 col-lg-6">
    <div className="card h-100 overflow-hidden">

      {/* IMAGE */}
      {item.type === "image" && (
        <img
          src={item.img}
          alt={item.title}
          className="w-100"
          style={{ height: "260px", objectFit: "cover" }}
        />
      )}

      {/* VIDEO */}
      {item.type === "video" && (
        <video
          src={item.img}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-100"
          style={{ height: "260px", objectFit: "cover" }}
        />
      )}

      {/* TEXT OVERLAY */}
      <div
        className="position-absolute bottom-0 start-0 w-100 p-3 text-white"
        style={{ background: "rgba(0,0,0,0.5)" }}
      >
        <h5 className="fw-bold mb-1">{item.title}</h5>
        <p className="mb-0 small">{item.desc}</p>
      </div>

    </div>
  </div>
);
export default Slider;









































